import type { Diagnostic } from './pif-partial-validation';
import type { BotCompilerError } from '../../utils/validate-csv';

const toNodeNum = (raw: string | undefined): number | null => {
  if (raw == null || raw === '') return null;
  const n = Number(raw);
  return Number.isNaN(n) ? null : n;
};

/**
 * Map agent-validator (PIF) diagnostics to the shared `BotCompilerError`
 * shape (PSTUDIO-3991).
 *
 * This only carries the diagnostic's RAW addressing data through — the stable
 * `node_id` (data.id), the `node_num` (data.nodeNumber) and the `column`
 * (data.propertyName). Turning those into concrete row/column INDICES is left
 * to `buildWorkflowErrors`, which resolves them (id-first) against the sorted
 * rows via `resolve-error-cell-address`. Keeping the transform index-free makes
 * it a pure function (no `tableStore`), and lets a blank node number still
 * resolve to a cell by id.
 */
export const transformPifDiagnostics = (
  diagnostics: Diagnostic[]
): BotCompilerError[] =>
  diagnostics.map((d) => ({
    row_num: null,
    node_num: toNodeNum(d.data?.nodeNumber),
    node_id: d.data?.id ?? null,
    node_index: null,
    cell_num: null,
    cell_index: null,
    column: d.data?.propertyName || undefined,
    err_msgs: [{ error_description: d.message }],
  }));
